export default function PreviewMenu() {
  return (
    <section style={{ padding: "48px 24px" }}>
      <h2 style={{ color: "#fff", fontWeight: 800 }}>
        Menu
      </h2>
      <p style={{ color: "#9ca3af" }}>
        Menu categories and items will render here.
      </p>
    </section>
  );
}
